import React from 'react'
import CollegesList from '../../../Components/CollegesList/colleges-list'

const CollegeList = () => {
  return (
    <div><CollegesList/></div>
  )
}

export default CollegeList